'use strict';
const angular = require('angular');

/*@ngInject*/
export function PropertyService($resource) {
  return $resource('/api/properties/:id', {
    id: '@_id'
  },{
    getByContact: {
      method: 'GET',
      url: "/api/properties/contact/:contactId",
      isArray: true
    },
    getByCommunity: {
      method: 'GET',
      url: "/api/properties/community/:communityId",
      isArray: true
    },
    getContacts: {
      method: 'GET',
      url: "/api/properties/:id/contacts",
      isArray: true
    },
    update: {
      method: 'PUT'
    },
    patch: {
      method: 'PATCH'
    },
    addAttachments: {
      method: 'PUT',
      url: "/api/properties/:id/attachments"
    },
    getPropertiesByVoter: {
      method: 'GET',
      url: "/api/properties/voter/:contactId",
      isArray: true
    },
    queryWithContacts: {
      method: 'GET',
      url: "/api/properties/contacts",
      isArray: true
    }
  });
}


export default angular.module('conduu.PropertyService', [])
  .factory('PropertyService', PropertyService)
  .name;



// WEBPACK FOOTER //
// ./client/components/property/property.service.js